<template>
  <div class="banner">
    <img :src="bannerUrl" />
  </div>
</template>

<script>
export default {
    name: 'Special',
    props: {
        banner: {
            type: String,
            default () {
                return ''
            }
        }
    },
    data () {
        return {
            bannerUrl: ''
        }
    },
    created () {
    },
    mounted () {
        if (this.banner) {
            this.$nextTick(() => {
                this.bannerUrl = this.banner;
            })
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>

<style scope lang="less">
</style>
